export function validateBroadcast(data) {
    const start = new Date(data.start_recurrence);
    const end = new Date(data.end_recurrence);
    const dayOfWeek = data.day_of_week; // e.g., Sunday
    const weekOfMonth = data.week_of_month; // e.g., First
    const repeatInterval = data.repeat_interval; // e.g., 1 month
  
    const weekdayMap = {
      "Monday": 1, "Tuesday": 2, "Wednesday": 3, "Thursday": 4,
      "Friday": 5, "Saturday": 6, "Sunday": 0
    };
  
    const targetWeekday = weekdayMap[dayOfWeek];
    const results = [];
  
    let current = new Date(start.getFullYear(), start.getMonth(), 1); // First day of start month
  
    while (current <= end) {
      const month = current.getMonth();
      const year = current.getFullYear();
      const firstDay = new Date(year, month, 1);
      const daysInMonth = new Date(year, month + 1, 0).getDate();
  
      let broadcastDate = null;
      const weeks = [[]];
  
      // Build weeks
      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day);
        const dayOfWeek = date.getDay();
        if (weeks[weeks.length - 1].length === 7) {
          weeks.push([]);
        }
        weeks[weeks.length - 1][dayOfWeek] = day;
      }
  
      let weekIndex = 0;
      if (weekOfMonth === "First") weekIndex = 0;
      else if (weekOfMonth === "Second") weekIndex = 1;
      else if (weekOfMonth === "Third") weekIndex = 2;
      else if (weekOfMonth === "Fourth") weekIndex = 3;
      else if (weekOfMonth === "Last") weekIndex = -1;
      else return { possible: false, reason: "Invalid week_of_month" };
  
      if (weekIndex === -1) {
        for (let i = weeks.length - 1; i >= 0; i--) {
          if (weeks[i][targetWeekday]) {
            broadcastDate = new Date(year, month, weeks[i][targetWeekday]);
            break;
          }
        }
      } else {
        let week = weeks[weekIndex];
        if (!week[targetWeekday]) {
          week = weeks[weekIndex + 1];
        }
        if (week && week[targetWeekday]) {
          broadcastDate = new Date(year, month, week[targetWeekday]);
        }
      }
  
      if (broadcastDate && start <= broadcastDate && broadcastDate <= end) {
        results.push(broadcastDate.toISOString().slice(0, 10));
      }
  
      // Move to next month
      current = new Date(current.getFullYear(), current.getMonth() + repeatInterval, 1);
    }
  
    const possible = results.length > 0;
    return {
      possible: possible,
      count: results.length,
      dates: results
    };
  }
  
//   // Example usage
//   const data = {
//     broadcast_type: "recurring",
//     repeat_interval: 1,
//     monthly_pattern: "dayOfWeek",
//     week_of_month: "First",
//     day_of_week: "Sunday",
//     weekend_handling: "sendAnyway",
//     start_recurrence: "2025-04-28",
//     end_recurrence: "2025-04-30",
//     no_end_date: false,
//     broadcast_time: "16:00"
//   };
  
//   console.log(validateBroadcast(data));